import { POST_CREDIT_SERVICE_PENDING, POST_CREDIT_SERVICE_SUCCESS, POST_CREDIT_SERVICE_ERROR, POST_CREDIT_SERVICE_INIT } from './types'
import { postCreditService as postCreditServiceAPI } from '../../service/apis'
import { showMessage as showMessageAction, showSuccessBar as showSuccessBarAction } from '../message/action'
import { getMediumDataInit } from '../getMediumData/action'
import store from '../store'

const postCreditServicePending = () => {
  return {
    type: POST_CREDIT_SERVICE_PENDING,
  }
}

const postCreditServiceSuccess = (data: any, mediumNumber: string, creditAmount: number, exseOriginatorId: string) => {
  return {
    type: POST_CREDIT_SERVICE_SUCCESS,
    data,
    params: { mediumNumber, creditAmount, exseOriginatorId }
  }
}

const postCreditServiceError = (mediumNumber: string, creditAmount: number, exseOriginatorId: string) => {
  return {
    type: POST_CREDIT_SERVICE_ERROR,
    params: { mediumNumber, creditAmount, exseOriginatorId }
  }
}

export const postCreditServiceInit = () => {
  return {
    type: POST_CREDIT_SERVICE_INIT
  }
}

const MOCK_MEDIUM_DATA = process.env.REACT_APP_MOCK_MEDIUM_DATA === 'true';

const getMockPostCreditServiceResponse = (mediumNumber: string, creditAmount: number) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve({
      data: {
        data: {
          MediumNumber: mediumNumber,
          Amount: creditAmount
        }
      }
    }), 500)
  })
}

const formatCentsAsEuro = (amountInCent: number) => (amountInCent / 100).toFixed(2).replace('.', ',') + ' €'

// displayMediumNumber: what the user searched for (medium number or license plate), shown in the success bar
export const postCreditService = (mediumNumber: string, creditAmount: number, returnToSearch: boolean = false, displayMediumNumber: string = mediumNumber) => {
    const tenantID = store.getState().auth.user.tenantID;
    const exseOriginatorId = store.getState().auth.user.exseOriginatorId

    return (dispatch: any) => {
      dispatch(postCreditServicePending())

      const request = MOCK_MEDIUM_DATA
        ? getMockPostCreditServiceResponse(mediumNumber, creditAmount)
        : postCreditServiceAPI(tenantID, mediumNumber, creditAmount, exseOriginatorId)

      request
        .then(async (resp: any) => {
          if (returnToSearch) {
            // skip the result screen: go straight back to the (empty) search and show a success bar there
            dispatch(postCreditServiceInit())
            dispatch(getMediumDataInit())
            dispatch(showSuccessBarAction(
              'Die Parkentgeltbefreiung war erfolgreich.',
              `Medium ${displayMediumNumber} wurde um ${formatCentsAsEuro(creditAmount)} befreit.`
            ))
            return
          }
          dispatch(postCreditServiceSuccess(resp.data.data, mediumNumber, creditAmount, exseOriginatorId))
        })
        .catch((err: any) => {
          dispatch(postCreditServiceError(mediumNumber, creditAmount, exseOriginatorId))
          dispatch(showMessageAction(2, 'Gutschrift konnte nicht erfolgen', err + ''))
        })
    }
}